import {BandwidthLimit} from '../types/interfaces/bandwidth-limit.interface';
import {PacketLoss} from '../types/interfaces/packet-loss.interface';

export const bandwidthLimitConfigurations: BandwidthLimit[] = [
    {name: 'GPRS', strength: 1, apiName: 'gprs', limit: '56kb/s'},
    {name: 'EDGE', strength: 2, apiName: 'edge', limit: '220kb/s'},
    {name: '3G', strength: 2, apiName: 'umts', limit: '376kb/s'},
    {name: 'HSPA', strength: 3, apiName: 'hspa_low', limit: '7.2mb/s'},
    {name: 'HSPA+', strength: 4, apiName: 'hspa_high', limit: '24.7mb/s'},
    {name: 'LTE', strength: 5, apiName: 'lte', limit: '100mb/s'},
    {name: 'DSL 2000', strength: 2, apiName: 'dsl_2m', limit: '2mb/s'},
    {name: 'DSL 4000', strength: 3, apiName: 'dsl_4m', limit: '4mb/s'},
    {name: 'DSL 8000', strength: 3, apiName: 'dsl_8m', limit: '8mb/s'},
    {name: 'DSL 16000', strength: 4, apiName: 'dsl_16m', limit: '16mb/s'},
    {name: 'DSL 32000', strength: 5, apiName: 'dsl_32m', limit: '32mb/s'}
];

export const packetLossConfigurations: PacketLoss[] = [
    {strength: 4, apiName: '1%'},
    {strength: 3, apiName: '5%'},
    {strength: 2, apiName: '20%'},
    {strength: 1, apiName: '50%'},
    {strength: 0, apiName: '100%'}
];
